import React from 'react';
import KeyValueTable from './KeyValueTable';

/*
 * SunMoonTimesSection — Section 3 of Pambu Sheet.
 *
 * Six rows: sunrise, sunset, moonrise, moonset, day length, night length.
 * Times in HH:MM:SS (astrologers cross-check vs printed Pambu Panchangam).
 */

const SunMoonTimesSection = ({ sunMoon, lang = 'en' }) => {
  if (!sunMoon) return null;

  const rows = [
    { key: 'sunrise',  labelTa: 'சூரிய உதயம்',   labelEn: 'Sunrise',     value: sunMoon.sunrise   || '—' },
    { key: 'sunset',   labelTa: 'சூரிய அஸ்தமம்', labelEn: 'Sunset',      value: sunMoon.sunset    || '—' },
    { key: 'moonrise', labelTa: 'சந்திர உதயம்',  labelEn: 'Moonrise',    value: sunMoon.moonrise  || '—' },
    { key: 'moonset',  labelTa: 'சந்திர அஸ்தமம்', labelEn: 'Moonset',    value: sunMoon.moonset   || '—' },
    { key: 'dinamana', labelTa: 'பகல் நீளம்',    labelEn: 'Day length',  value: sunMoon.dinamana  || sunMoon.day_length  || '—' },
    { key: 'ratrimana',labelTa: 'இரவு நீளம்',    labelEn: 'Night length',value: sunMoon.ratrimana || sunMoon.night_length || '—' },
  ];

  return <KeyValueTable rows={rows} lang={lang} />;
};

export default SunMoonTimesSection;
